function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable class-methods-use-this */
import Resource from "./common";
import Api from "../api";

var MediaResource = /*#__PURE__*/function (_Resource) {
  _inherits(MediaResource, _Resource);

  var _super = _createSuper(MediaResource);

  function MediaResource() {
    var entrypoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/media';
    var alias = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Media';

    _classCallCheck(this, MediaResource);

    return _super.call(this, entrypoint, alias);
  }

  _createClass(MediaResource, [{
    key: "canReadList",
    value: function canReadList() {
      return false;
    }
  }, {
    key: "canCreate",
    value: function canCreate() {
      return false;
    }
  }, {
    key: "canUpdate",
    value: function canUpdate() {
      return false;
    }
    /** resource au pluriel ex: communities  */

  }, {
    key: "createResource",
    value: function () {
      var _createResource = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resource, prop, files, multiple, subFileSaving, filename) {
        var medias, f, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                medias = [];

                for (f = 0; f < files.length; f++) {
                  medias.push(this.fetchMedia(resource, prop, files[f], subFileSaving, filename));
                }

                _context.next = 4;
                return Promise.all(medias);

              case 4:
                response = _context.sent;
                return _context.abrupt("return", response.length > 1 ? response : response[0]);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createResource(_x, _x2, _x3, _x4, _x5, _x6) {
        return _createResource.apply(this, arguments);
      }

      return createResource;
    }()
  }, {
    key: "fetchMedia",
    value: function () {
      var _fetchMedia = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resource, prop, file, subFileSaving, filename) {
        var bodyFormData, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                bodyFormData = new FormData();
                bodyFormData.append('file', file, filename || 'logo');

                if (subFileSaving) {
                  bodyFormData.append('subFileSaving', "".concat(subFileSaving));
                }

                if (filename) {
                  bodyFormData.append('filename', "".concat(filename));
                }

                _context2.next = 6;
                return Api.post("/".concat(resource, "/media?prop=").concat(prop), bodyFormData, null, null, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 6:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fetchMedia(_x7, _x8, _x9, _x10, _x11) {
        return _fetchMedia.apply(this, arguments);
      }

      return fetchMedia;
    }()
  }]);

  return MediaResource;
}(Resource);

export { MediaResource as default };